import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import s from './EditUserEmailModal.css';
import cs from '../../../components/commonStyle.css';
import messages from '../../../locale/messages';

class EditUserEmailModal extends Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    userId: PropTypes.string,
    currentEmail: PropTypes.string,
    onSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = { email: '' };
  }

  componentDidUpdate(prevProps) {
    if (this.props.show && !prevProps.show) {
      this.setState({ email: '' });
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { userId, onSubmit } = this.props;
    const { email } = this.state;
    if (userId && email.trim()) {
      onSubmit(userId, email.trim());
    }
  };

  render() {
    const { show, onHide, currentEmail, submitting } = this.props;
    const { formatMessage } = this.props.intl;
    const { email } = this.state;

    return (
      <Modal show={show} onHide={onHide} className="adminModal">
        <Modal.Header closeButton>
          <Modal.Title>{formatMessage(messages.editUserEmailTitle)}</Modal.Title>
        </Modal.Header>
        <Modal.Body className={s.modalBody}>
          <form className={cx('adminstyle', s.form)} onSubmit={this.handleSubmit}>
            <div className={s.fieldGroup}>
              <label className={cx(cs.labelTextNew, cs.fontWeightMedium, s.label)}>
                {formatMessage(messages.emailLabel)}
              </label>
              <p className={cx(cs.commonContentText, s.currentEmail)}>{currentEmail}</p>
            </div>
            <div className={s.fieldGroup}>
              <label
                className={cx(cs.labelTextNew, cs.fontWeightMedium, s.label)}
                htmlFor="adminNewUserEmail"
              >
                {formatMessage(messages.newUserEmailLabel)}
              </label>
              <input
                id="adminNewUserEmail"
                type="email"
                required
                className={cx(cs.formControlInput, s.inputFullWidth)}
                value={email}
                onChange={(e) => this.setState({ email: e.target.value })}
                autoComplete="off"
              />
            </div>
            <div className={s.actions}>
              <Button type="button" onClick={onHide} className={cs.btnSecondary}>
                {formatMessage(messages.cancel)}
              </Button>
              <Button type="submit" disabled={submitting || !email.trim()} className={cs.btnPrimary}>
                {formatMessage(messages.save)}
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    );
  }
}

export default injectIntl(withStyles(s, cs)(EditUserEmailModal));
